import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import {
    Section,
    SectionTitle,
    Typography,
    Image,
} from 'wanderu-components';
import { theme } from 'wanderu-css';
import { localize } from 'wanderu-i18n';

import chikuDiscountPeekMobile from 'wanderu-assets/images/wanderu_exclusive_small_peek-horizontal_prod.png';
import chikuDiscountPeekDesktop from 'wanderu-assets/images/wanderu_exclusive_small_peek_prod.png';

import styles from './PromoBox.scss';

const propTypes = {
    className: PropTypes.string,
    locale: PropTypes.string,
    route: PropTypes.string,
    t: PropTypes.func,
};
const defaultProps = {
    className: '',
};

function PromoBox(props) {
    const {
        className,
        locale,
        route,
        t,
    } = props;
    const isCorrectLocale = locale === 'en-us';
    return (
        <>
            {isCorrectLocale
                ? (
                    <Section
                        className={classNames(
                            styles.section,
                            className,
                            {
                                [styles.homepage]: route === 'homepage',
                            }
                        )}
                        id="promo-box"
                    >
                        <div className={styles.layout}>
                            <div className={styles.leftColumn}>
                                <picture className={styles.imageContainer}>
                                    <source
                                        media={theme.breakpointsDown('sm')}
                                        srcSet={chikuDiscountPeekMobile}
                                    />
                                    <source
                                        media={theme.breakpointsUp('sm')}
                                        srcSet={chikuDiscountPeekDesktop}
                                    />
                                    <Image
                                        alt="chiku-discount-peek"
                                        className={styles.discountImage}
                                        src={chikuDiscountPeekDesktop}
                                    />
                                </picture>
                            </div>

                            <div className={styles.rightColumn}>
                                <SectionTitle className={styles.title}>
                                    {t('exclusive-banner-title')}
                                </SectionTitle>
                                <Typography className={styles.subtitle} variant="body1">
                                    {t('exclusive-banner-text')}
                                </Typography>
                            </div>
                        </div>
                    </Section>
                )
                : null}
        </>
    );
}

PromoBox.propTypes = propTypes;
PromoBox.defaultProps = defaultProps;

export default localize(PromoBox, ['t'], 'baseApp');
